module.exports = {"devEnv":false,"prodEnv":true,"refreshTokenTime":60000,"serverPort":"localhost","serverUrl":"https://www.dot.nd.gov/dot/techcert","clientHomeUrl":"https://www.dot.nd.gov/dot/techcert","version":"2026-01-06-prod-tech-cert-20260106.3"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 12
// module chunks = 0